import { Button, Card, CardActions, Collapse, TableCell} from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";
import {
    bbDangerousStringToDate,
    bbFormattedDateString,
    bbIsRequestedAttackDetailed,
    bbShortenString, isCurrentUserMemberOf
} from "../../../util/bbHelpers";

import { makeStyles } from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import Typography from "@material-ui/core/Typography";
import BBIconLevelUpArrowEscalation from "../../../assets/bbCustomIcons/BBIconLevelUpArrowEscalation";
import BBIconCircleRightChevron from "../../../assets/bbCustomIcons/BBIconCircleRightChevron";
import BBIconSatelliteDish from "../../../assets/bbCustomIcons/BBIconSatelliteDish";
import BBIconRadarSweepWithTargets from "../../../assets/bbCustomIcons/BBIconRadarSweepWithTargets";
import BBIconTeePeeCampPersist from "../../../assets/bbCustomIcons/BBIconTeePeeCampPersist";
import BBIconArrowLeftRightLateral from "../../../assets/bbCustomIcons/BBIconArrowLeftRightLateral";
import BBIconEvadeAvoid from "../../../assets/bbCustomIcons/BBIconEvadeAvoid";
import BBIconCredentialIdBadge from "../../../assets/bbCustomIcons/BBIconCredentialIdBadge";
import BBIconCollectionMagnifyingGlass from "../../../assets/bbCustomIcons/BBIconCollectionMagnifyingGlass";
import BBIconExfiltrationSteal from "../../../assets/bbCustomIcons/BBIconExfiltrationSteal";
import BBIconDoor from "../../../assets/bbCustomIcons/BBIconDoor";
import BBIconCode from "../../../assets/bbCustomIcons/BBIconCode";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import BBIconCalendarCheck from "../../../assets/bbCustomIcons/BBIconCalendarCheck";
import BBIconInProgressPie from "../../../assets/bbCustomIcons/BBIconInProgressPie";
import BBIconCheck from "../../../assets/bbCustomIcons/BBIconCheck";
import BBIconShieldBounce from "../../../assets/bbCustomIcons/BBIconShieldBounce";
import BBIconAbortStop from "../../../assets/bbCustomIcons/BBIconAbortStop";
import IconButton from "@material-ui/core/IconButton";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import {useSelector} from "react-redux";
import BBIconExternalLink from "../../../assets/bbCustomIcons/BBIconExternalLink";
import {Badge} from "reactstrap";
import BBIconConstructionCone from "../../../assets/bbCustomIcons/BBIconConstructionCone";
import BBCodeCopyContainer from "../controllers/BBCodeCopyContainer";
import Link from "@material-ui/core/Link";
import BBIconCodeDocument from "../../../assets/bbCustomIcons/BBIconCodeDocument";
import BBIconPrinterOutput from "../../../assets/bbCustomIcons/BBIconPrinterOutput";
import BBIconWarningTriangle from "../../../assets/bbCustomIcons/BBIconWarningTriangle";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        textAlign: "center",
        padding: '6px 16px',
    },
    leafHeading : {
        textAlign: "left"
    },
    secondaryTail: {
        backgroundColor: theme.palette.secondary.main,
    },
    footNote: {
        marginLeft: "auto",
        marginRight: theme.spacing(2),
        // float: "right",
        fontSize: "smaller",
        color: 'gray'
    },
    centerFootNote: {
        marginLeft: 'auto',
        marginRight: 'auto',
        fontSize: "smaller",
        color: 'gray'
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    expandIcon: {
        fontSize: 16,
    },
    footer: {

        // borderTop: "solid 2px gray",
        // borderBottom: "solid 9px gray",
        padding: 0,
    },
    collapse: {

    },
}));

const AttackTimeLineZigzag = (props) => {
    const classes = useStyles();

    const {detailedAttackObject} = props;
    const authUser = useSelector(({auth}) => auth.authUser);

    const [expanded, setExpanded] = React.useState({});
    const [showAll, setShowAll] = React.useState(false);
    // const [page, setPage] = React.useState(1);
    const eventsPerPage = 50;
    const handleExpandClick = (id) => {
        setExpanded({
            ...expanded,
            [id]: !expanded[id]
        }
        );
    };
    const handleShowAll = () => {
        setShowAll(true);
    };



    //validate input
    if(!detailedAttackObject ) {
        console.warn("AttackTimeLineZigzag received a null or empty object", detailedAttackObject);
        return <></> //fail silent
    } else if (!bbIsRequestedAttackDetailed(detailedAttackObject) || !detailedAttackObject.hasOwnProperty("Events")) {
        console.warn("AttackTimeLineZigzag received an object that failed the detailed check. Input: ", detailedAttackObject, "evaluated to via bbIsRequestedAttackDetailed(detailedAttackObject)", bbIsRequestedAttackDetailed(detailedAttackObject), "detailedAttackObject.hasOwnProperty(\"Events\")", detailedAttackObject.hasOwnProperty("Events"));
        return <></> //fail silent
    }

    //events is an array
    const events = detailedAttackObject.Events.sort((a,b) => bbDangerousStringToDate(a["Created DateTime"]) - bbDangerousStringToDate(b["Created DateTime"]));

    const showAllSliceStart = 0;
    const showAllSliceEnd = events.length - 1;

    // "Id": "0ee183bd-e385-4adb-879a-9b0b0215fee8",
//         "Created DateTime": "2020-12-02 02:50:02",
//         "Event Type": {
//             "Id": 2,
//             "Name": "Command & Control Event",

    //shifted timeline over to using vaniall material
    //https://material-ui.com/components/timeline/

    const displayIconByEventType = (typeId) => {
        // Id	Name	EventCategory	Description	EventImageUrl
        // 1	Execution Event	1	Event detailing an execution event attempted or achieved during an attack.
        // 2	Command & Control Event	1	Event detailing command and control (C2) activity associated with an attack.
        // 3	Privilege Escalation Event	1	Event detailing privilege escalation (privesc) activity attempted or achieved during an attack.
        // 4	Discovery Event	1	Event detailing discovery or reconnaissance activity attempted or achieved during an attack.
        // 5	Lateral Movement Event	1	Event detailing lateral movement activity attempted or achieved during an attack.
        // 6	Persistance Event	1	Event detailing persistance activity attempted or achieved during an attack.
        // 7	Defense Evasion Event	1	Event detailing defense evasion activity attempted or achieved during an attack.
        // 8	Credential Access Event	1	Event detailing credential access activity attempted or achieved during an attack.
        // 9	Collection Event	1	Event detailing data collection activity attempted or achieved during an attack.
        // 10	Exfiltration Event	1	Event detailing data exfiltration activity attempted or achieved during an attack.
        // 54	Initial Access Event	1	Event detailing the initial access into a target network or host.
        switch(typeId) {
            case 1:
                return <BBIconCode/>
            case 2:
                return <BBIconSatelliteDish/>
            case 3:
                return <BBIconLevelUpArrowEscalation/>
            case 4:
                return <BBIconRadarSweepWithTargets/>
            case 5:
                return <BBIconArrowLeftRightLateral/>
            case 6:
                return <BBIconTeePeeCampPersist/>
            case 7:
                return <BBIconEvadeAvoid/>
            case 8:
                return <BBIconCredentialIdBadge/>
            case 9:
                return <BBIconCollectionMagnifyingGlass/>
            case 10:
                return <BBIconExfiltrationSteal/>
            case 54:
                return <BBIconDoor/>
            default:
                return <BBIconCircleRightChevron/>
        }
    }

    const displayIconByEventStatus = (eventStatusId) => {
        // Id	Name	Description	ImageUrl
        // 0	Planned	The event is planned for execution in an attack.
        // 1	Tasked	The event has been ordered by a command & control server for execution.
        //     2	Completed	The event was successfully completed in the attack.
        // 3	Defeated	The event was tasked for completion, but was stopped from successfully being executed on the target.
        // 4	Error	An error occurred while attempting to execute this event.
        // 5	Customer Aborted	Customer stopped this event from being completed on target.
        // 6	BreachBits Aborted	BreachBits Staff aborted this event from executing.
        switch(eventStatusId) {
            case 0:
                return <BBIconCalendarCheck/>
            case 1:
                return <BBIconInProgressPie className={"text-electric-blue"}/>
            case 2:
                return <BBIconCheck />
            case 3:
                return <BBIconShieldBounce/>
            case 4:
                return <BBIconWarningTriangle/>
            case 5:
            case 6:
                return <BBIconAbortStop/>
            default:
                return <BBIconCalendarCheck/>
        }
    }


    return (
        <>

        <Timeline align="alternate">
            {eventsPerPage < events.length - 1 && !showAll
                ? <h3 className={"text-center"}>Showing the most recent {eventsPerPage} events of {events.length} total
                    events. <br/><Tooltip title={"Show all events.  Warning: this feature is undergoing improvements and may cause performance issues for timelines with more than 200 events."}><Button variant={"outlined"} onClick={handleShowAll} >Show all events</Button></Tooltip></h3>
                : <h3 className={"text-center"}>{events.length} Events Total {showAll && <>(showing all)</>}</h3>

            }
            {eventsPerPage < events.length - 1 && !showAll &&
                <>

                    <h2 className={"text-center"}>…</h2>
                    <TimelineItem>
                        <TimelineOppositeContent/>
                        <TimelineSeparator>

                            <TimelineConnector/>

                        </TimelineSeparator>
                        <TimelineContent/>
                    </TimelineItem>
                </>

            }
            {events.length <= 0
                ? <em>There are no events in this attack timeline.</em>
            : events.slice(showAll ? showAllSliceStart : events.length - 1 - eventsPerPage, showAll ? showAllSliceEnd : events.length).map(data => {

                // console.log("About to parse this into JSON", data.Details);

                let detailFromJSON = null;
                let JSONError = false;
                let JSONErrorText = null;
                try {
                    let str = data.Details
                    str=str.replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t");
                    detailFromJSON = data.Details ? JSON.parse(str) : null;
                } catch(e)
                {
                    // detailFromJSON = "error parsing JSON for event details."
                    console.error("JSON error: ", e);
                    JSONErrorText = e;
                    JSONError= true;
                }

                return (
                    <TimelineItem key={data.Id} >
                        <TimelineOppositeContent>
                            <Typography variant="h6" color="textSecondary">
                                <Tooltip title={`${bbFormattedDateString(data["Created DateTime"], "utc")}`}>
                                    <span>
                                        {bbFormattedDateString(data["Created DateTime"], "mediumWithSeconds")}
                                    </span>
                                </Tooltip>
                            </Typography>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineDot className={ data["Status"].Id ===1 ? "bg-electric-blue mx-1" : "mx-1"} style={{zIndex: "3"}}>
                                <Tooltip title={`(${data["Status"].Name}) ${data["Event Type"].Name} | ${data["Event Type"].Description}`}>
                                    <span>
                                        {displayIconByEventType(data["Event Type"].Id)}
                                    </span>
                                </Tooltip>
                            </TimelineDot>
                            {(events[events.length-1].Id !== data.Id || detailedAttackObject.Status.Id === 2) &&
                                <TimelineConnector/>}

                        </TimelineSeparator>
                        <TimelineContent className= {data["Status"].Id ===1 ? "bg-electric-blue-light pulse pulse-slow py-3 mb-5" : "mb-5"} style={{borderRadius:"6px", zIndex:"2"}}>
                            <Card className={clsx(classes.root, "") } elevation={3}>
                                <Typography variant="h5" className={classes.leafHeading}>
                                    {data["Event Type"].Name}
                                    <Tooltip title={data["Event Type"].Description}>
                                        <InfoSharpIcon style={{fontSize: "medium"}} className={"mx-1"}/>
                                    </Tooltip>
                                    <div className={"float-right mx-1"}>
                                        <Tooltip title={`As of ${bbFormattedDateString(data["Status As Of DateTime"], "medium")} the status of this event is: ${data["Status"].Name} | ${data["Status"].Description}`}>
                                            <span>
                                                {displayIconByEventStatus(data["Status"].Id)}
                                            </span>
                                        </Tooltip>
                                    </div>
                                    <div className={"float-right mx-1"}>
                                        <Tooltip title={(!JSONError && detailFromJSON && detailFromJSON.hasOwnProperty("details") && !!detailFromJSON.details) ? `Output Viewer Available to view (expand this event bubble).` : `No Output Viewer available in this event.`}>
                                            <span>
                                                {(!JSONError && detailFromJSON && detailFromJSON.hasOwnProperty("details") && !!detailFromJSON.details)
                                                    ?<BBIconPrinterOutput className={"text-electric-blue"}/>
                                                    :<BBIconPrinterOutput className={"text-light-grey"}/>
                                                }
                                            </span>
                                        </Tooltip>
                                    </div>
                                    <div className={"float-right mx-1"}>
                                        <Tooltip title={data["Tactic Details"]["Command"] ? `Command Viewer Available to view (expand this event bubble).` : `No Command Viewer available in this event.`}>
                                            <span>
                                                {data["Tactic Details"]["Command"]
                                                    ?<BBIconCodeDocument className={"text-electric-blue"}/>
                                                    :<BBIconCodeDocument className={"text-light-grey"}/>
                                                }
                                            </span>
                                        </Tooltip>
                                    </div>

                                </Typography>
                                <div className={"px-5 mx-5 my-2"} style={{fontSize: "medium"}}>
                                    <Tooltip title={`${data["Tactic Details"]["Difficulty"]["Description"]}`}>
                                                    <span>
                                                        <Badge className={"d-block"} color={data["Tactic Details"]["Difficulty"]["Id"] === 1 ? "bb-risk-low" : data["Tactic Details"]["Difficulty"]["Id"] === 2 ? "bb-risk-medium" : "bb-risk-high"}>{data["Tactic Details"]["Difficulty"]["Name"]}</Badge>
                                                    </span>
                                    </Tooltip>
                                </div>

                                {/*<Typography variant="h6" >MITRE ATT&CK Info</Typography>*/}
                                <Table size="small" >
                                    <TableBody>
                                        <TableRow >
                                            <TableCell >
                                                Tactic
                                            </TableCell>
                                            <TableCell >
                                                <Tooltip title={`(External Link) Learn more about the MITRE ATT&CK Tactic "${data["Tactic Details"]["Att&ck Name"]}" (Tactic ID ${data["Tactic Details"]["Att&ckId"]}) at MITRE.org in a new window.`}>
                                                    <Link target="_blank" rel="noopener" href={data["Tactic Details"]["Att&ck Url"]}>
                                                        {data["Tactic Details"]["Att&ck Name"]} <BBIconExternalLink style={{fontSize: "smaller"}}/>
                                                    </Link>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow >
                                            <TableCell >
                                                Description
                                            </TableCell>
                                            <TableCell >
                                                {data["Tactic Details"]["Description"]}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow >
                                            <TableCell >
                                                Category
                                            </TableCell>
                                            <TableCell >
                                                {data["Tactic Details"]["Att&ck Category"]}
                                            </TableCell>
                                        </TableRow>
                                        {/*<TableRow >*/}
                                        {/*    <TableCell >*/}
                                        {/*        Difficulty*/}
                                        {/*    </TableCell>*/}
                                        {/*    <TableCell >*/}

                                        {/*        {data["Tactic Details"]["Difficulty"]["Name"]}*/}

                                        {/*        <Tooltip title={data["Tactic Details"]["Difficulty"]["Description"]}>*/}
                                        {/*            <InfoSharpIcon style={{fontSize: "smaller"}} className={"mx-1"}/>*/}
                                        {/*        </Tooltip>*/}

                                        {/*    </TableCell>*/}
                                        {/*</TableRow>*/}

                                    </TableBody>
                                </Table>
                                <br/>

                                <Tooltip title={"Expand for more information."}>
                                    <CardActions disableSpacing  className={classes.footer} onClick={() => handleExpandClick(data.Id)} type={"button"}>
                                        {/*<IconButton aria-label="add to favorites">*/}
                                        {/*    <FavoriteIcon />*/}
                                        {/*</IconButton>*/}
                                        {/*<IconButton aria-label="share">*/}
                                        {/*    <ShareIcon />*/}
                                        {/*</IconButton>*/}
                                        <Typography className={classes.footNote} >

                                        </Typography>
                                        <Typography className={classes.centerFootNote} > Expand for more details</Typography>
                                        <Typography className={classes.footNote} > </Typography>


                                        <IconButton
                                            className={clsx(classes.expand, {
                                                [classes.expandOpen]: expanded[data.Id],
                                            })}

                                            aria-expanded={expanded[data.Id]}
                                            aria-label="show more"
                                        >
                                            <ExpandMoreIcon className={classes.expandIcon} />
                                        </IconButton>
                                    </CardActions>
                                </Tooltip>
                                <Collapse in={expanded[data.Id]} timeout="auto" unmountOnExit className={classes.collapse}>
                                    {/*<CardContent>*/}

                                        <Table size="small" >
                                            <TableBody>
                                                    <TableRow >
                                                        <TableCell >
                                                            Event ID
                                                        </TableCell>
                                                        <TableCell style={{fontSize: "smaller"}}>
                                                            {data.Id}
                                                        </TableCell>
                                                    </TableRow>
                                                <TableRow >
                                                    <TableCell >
                                                        Created
                                                    </TableCell>
                                                    <TableCell style={{fontSize: "smaller"}}>
                                                        {bbFormattedDateString(data["Created DateTime"], "mediumWithSeconds")}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell >
                                                        Created (UTC)
                                                    </TableCell>
                                                    <TableCell style={{fontSize: "smaller"}}>
                                                        {bbFormattedDateString(data["Created DateTime"], "utc")}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell >
                                                        Last Updated
                                                    </TableCell>
                                                    <TableCell style={{fontSize: "smaller"}}>
                                                        {bbFormattedDateString(data["Status As Of DateTime"], "mediumWithSeconds")}
                                                    </TableCell>
                                                </TableRow>
                                                {isCurrentUserMemberOf(authUser, "admin") &&
                                                    <>
                                                        <TableRow >
                                                            <TableCell colSpan={2} className={"text-center"}><small><em>-- Following visible to admins only --</em></small></TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Target ID
                                                            </TableCell>
                                                            <TableCell style={{fontSize: "smaller"}}>
                                                                {data["TargetId"]}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Created By
                                                            </TableCell>
                                                            <TableCell>
                                                                {data["Created By"]}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Tasked Session
                                                            </TableCell>
                                                            <TableCell>
                                                                {data["Tasked Session"]}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Shell
                                                            </TableCell>
                                                            <TableCell >
                                                                {data["Tactic Details"]["Shell"]}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Module
                                                            </TableCell>
                                                            <TableCell >
                                                                {data["Tactic Details"]["Module"]}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Proxy
                                                            </TableCell>
                                                            <TableCell >
                                                                {data["Tactic Details"]["Proxy"]}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Parser
                                                            </TableCell>
                                                            <TableCell >
                                                                {data["Tactic Details"]["Parser"]}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Required Data
                                                            </TableCell>
                                                            <TableCell >
                                                                {data["Tactic Details"]["Required Data"]}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Related Event Type
                                                            </TableCell>
                                                            <TableCell >
                                                                {data["Tactic Details"]["Related Event Type"]}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Params
                                                            </TableCell>
                                                            <TableCell >
                                                                {data["Tactic Details"]["Params"]}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Language
                                                            </TableCell>
                                                            <TableCell >
                                                                {data["Tactic Details"]["Language"]}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow >
                                                            <TableCell >
                                                                Command
                                                            </TableCell>
                                                            <TableCell >
                                                                {data["Tactic Details"]["Command"]}
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                }

                                            </TableBody>
                                        </Table>
                                    {/*</CardContent>*/}
                                    <br/>
                                    {data["Tactic Details"]["Command"] &&
                                    <>
                                        <h3>Command</h3>
                                        <BBCodeCopyContainer displayText={data["Tactic Details"]["Command"]} titleDescriber={"Command"} titleIcon={<BBIconCodeDocument className={"text-electric-blue"}/>}/>
                                    </>
                                    }


                                    {JSONError
                                        ? <><Tooltip title={`${data.Details} ${isCurrentUserMemberOf(authUser, "admin") ? JSONErrorText : ""}`}><small><BBIconConstructionCone style={{fontSize: "smaller"}} className={"mx-1 text-bb-risk-high"}/><em>There is more information to display, but this feature is currently being enhanced. Thank you for your patience.</em></small></Tooltip></>
                                        : detailFromJSON && detailFromJSON.hasOwnProperty("details") && !!detailFromJSON.details
                                            ? <>
                                                {/*<p>Results: {detailFromJSON.results}</p>*/}
                                                <h3>Output</h3>
                                                {/*<h3>Output:</h3>*/}
                                                <BBCodeCopyContainer displayText={detailFromJSON.details} titleDescriber={"Output"} fileType={"data:text/plain;charset=utf-8"} titleIcon={<BBIconPrinterOutput className={"text-electric-blue"}/>} showDownload isNotExecutable fileName={`BB_AttackEvent_Output_ID_${bbShortenString(data.AttackId, 8)}_Event_${bbShortenString(data.Id, 8)}.txt`}/>
                                            </>
                                            : null
                                    }


                                    <br/>
                                </Collapse>

                            </Card>

                        </TimelineContent>

                    </TimelineItem>
                )
            })
            }
            {detailedAttackObject.Status.Id === 2  &&
            <>

                <TimelineItem>
                    <TimelineOppositeContent/>
                    <TimelineSeparator>

                        <TimelineConnector/>

                    </TimelineSeparator>
                    <TimelineContent/>
                </TimelineItem>
                <h2 className={"text-center"}>…</h2>
            </>

            }

        </Timeline>

            <h2 className={"text-center"}>
                {detailedAttackObject.Status.Id === 2 //2 is ongoing
                    ? "This attack is ongoing."
                    : events.length > 0
                        ?"This attack has concluded.  There are no more events to display."
                        : ""
                }
            </h2>
        </>
    );

    // return (
    //     <CmtTimeLine align={text('align', 'zigzag')}>
    //
    //         {events.map(data => (
    //             <CmtTimeLineItem
    //                 head={
    //                     <Box>
    //                         <Avatar src="https://via.placeholder.com/150" />
    //                         <Box component="p" mb={0} mt={2}>
    //                             {data["Created DateTime"]}
    //                         </Box>
    //                     </Box>
    //                 }
    //                 point={<BBIconAdd/>}
    //                 content={
    //                     <CmtTimelineContent isWrapper={true}>
    //                         <Box component="h2" fontSize={20} mt={0} mb={3}>
    //                             {data["Event Type"].Name}
    //                         </Box>
    //                         <Box component="p" mt={0}>
    //                             {data["Event Type"].Description}
    //                         </Box>
    //                     </CmtTimelineContent>
    //                 }
    //             />
    //         ))}
    //     </CmtTimeLine>
    // )
};

AttackTimeLineZigzag.propTypes = {
    detailedAttackObject: PropTypes.object.isRequired,
};



export default AttackTimeLineZigzag;


//example events data (from id 6477b797-6e38-44e5-819b-71cc1861d28a)
// "Events": [
//     {
//         "Id": "0ee183bd-e385-4adb-879a-9b0b0215fee8",
//         "Created DateTime": "2020-12-02 02:50:02",
//         "Event Type": {
//             "Id": 2,
//             "Name": "Command & Control Event",
//             "Event Category": 1,
//             "Description": "Event detailing command and control (C2) activity associated with an attack.",
//             "Event Image Url": null
//         },
//         "Details": "{\"results\": \"success\", \"details\": \"{\"Ip Public\": \"20.185.24.162\", \"Ip Private\": \"10.0.0.4\"}\"}",
//         "AttackId": "6477b797-6e38-44e5-819b-71cc1861d28a",
//         "TacticId": "WC2001",
//         "Tactic Details": {
//             "TacticId": "WC2001",
//             "Toolkit": {
//                 "Id": 99,
//                 "Name": "All",
//                 "Description Short": "No specific toolkit needed.  Tactic capable of being run by any toolkit on the target OS.",
//                 "Description Long": "No specific toolkit needed.  Tactic capable of being run by any toolkit on the target OS."
//             },
//             "OS Supported": {
//                 "Id": 100,
//                 "Name": "Universal",
//                 "Description": "Univeral across all operating systems.",
//                 "Logo": "https://resources.breachbits.co/logos/universal.png"
//             },
//             "Att&ck Category": "Command and Control",
//             "Att&ckId": "T1043",
//             "Requires Admin": 0,
//             "Description": "Use commonly used ports and services for C2, such as HTTP/S.",
//             "Language": null,
//             "Command": null,
//             "Params": null,
//             "Att&ck Name": "Commonly Used Port",
//             "Att&ck Url": "https://attack.mitre.org/techniques/T1043/",
//             "Tactic Name": "C2 via common ports and services",
//             "Module": 0,
//             "Shell": 0,
//             "Proxy": 0,
//             "Difficulty": {
//                 "Id": 1,
//                 "Name": "Basic",
//                 "Description": "Attack involving the simplest and most straightforward tools and tactics that are accessible to attackers of even the lowest skill level.  No obfuscation or defense evasion techniques attempted."
//             },
//             "Parser": null,
//             "Required Data": null,
//             "Related Event Type": 2
//         },
//         "Status As Of DateTime": "2020-12-02 02:50:02",
//         "Status": {
//             "Id": 2,
//             "Name": "Completed",
//             "Description": "The event was successfully completed in the attack.",
//             "Image Url": null
//         },
//         "TaskId": null,
//         "TargetId": "701bad5b57bb2b9ec8a735ed9c4030bbd7485519",
//         "Tasked Session": "10",
//         "Created By": 1
//     },
//     {
//         "Id": "2e7f5f7c-517b-428d-9534-a5280dd95f8d",
//         "Created DateTime": "2020-12-02 02:49:07",
//         "Event Type": {
//             "Id": 2,
//             "Name": "Command & Control Event",
//             "Event Category": 1,
//             "Description": "Event detailing command and control (C2) activity associated with an attack.",
//             "Event Image Url": null
//         },
//         "Details": "{\"results\": \"success\", \"details\": \"{\"Ip Public\": \"20.185.24.162\", \"Ip Private\": \"10.0.0.4\"}\"}",
//         "AttackId": "6477b797-6e38-44e5-819b-71cc1861d28a",
//         "TacticId": "WC2001",
//         "Tactic Details": {
//             "TacticId": "WC2001",
//             "Toolkit": {
//                 "Id": 99,
//                 "Name": "All",
//                 "Description Short": "No specific toolkit needed.  Tactic capable of being run by any toolkit on the target OS.",
//                 "Description Long": "No specific toolkit needed.  Tactic capable of being run by any toolkit on the target OS."
//             },
//             "OS Supported": {
//                 "Id": 100,
//                 "Name": "Universal",
//                 "Description": "Univeral across all operating systems.",
//                 "Logo": "https://resources.breachbits.co/logos/universal.png"
//             },
//             "Att&ck Category": "Command and Control",
//             "Att&ckId": "T1043",
//             "Requires Admin": 0,
//             "Description": "Use commonly used ports and services for C2, such as HTTP/S.",
//             "Language": null,
//             "Command": null,
//             "Params": null,
//             "Att&ck Name": "Commonly Used Port",
//             "Att&ck Url": "https://attack.mitre.org/techniques/T1043/",
//             "Tactic Name": "C2 via common ports and services",
//             "Module": 0,
//             "Shell": 0,
//             "Proxy": 0,
//             "Difficulty": {
//                 "Id": 1,
//                 "Name": "Basic",
//                 "Description": "Attack involving the simplest and most straightforward tools and tactics that are accessible to attackers of even the lowest skill level.  No obfuscation or defense evasion techniques attempted."
//             },
//             "Parser": null,
//             "Required Data": null,
//             "Related Event Type": 2
//         },
//         "Status As Of DateTime": "2020-12-02 02:49:07",
//         "Status": {
//             "Id": 2,
//             "Name": "Completed",
//             "Description": "The event was successfully completed in the attack.",
//             "Image Url": null
//         },
//         "TaskId": null,
//         "TargetId": "701bad5b57bb2b9ec8a735ed9c4030bbd7485519",
//         "Tasked Session": "10",
//         "Created By": 1
//     },